<template>
    <div v-if="initialized" class="tabs">
        <!-- header (no use atm) -->
        <div v-if="_.values(sections).length > 1" class="card-header card-header-inner">
            <ul role="tablist" tabindex="0" class="nav nav-tabs card-header-tabs">
                <li v-for="section in sections"
                    v-show="!_.isEmpty(getSectionEntries(section))"
                    :key="section"
                    role="presentation"
                    class="nav-item">
                    <a v-on:click="changeTab(section)"
                        role="tab" tabindex="-1" href="javascript:void(0)"
                        :class="['nav-link', 'nav-link-left', section == currentSection ? 'active' : '']"
                        >{{ __(section, ['titleCase']) }}</a>
                </li>
            </ul>
        </div>

        <div class="tab-content no-border pt-3">
            <div role="tabpanel" class="tab-pane card-body show fade active">
                <div class="card-body">
                    <div class="tabs row">
                        <!-- disable vertical tabs -->
                        <div v-if="false && _.values(sections).length > 1" class="col-auto w-180">
                            <ul role="tablist" tabindex="0" class="nav nav-tabs flex-column border-bottom-0 rounded-0">
                                <li v-for="section in sections"
                                    v-show="!_.isEmpty(getSectionEntries(section))"
                                    :key="section"
                                    role="presentation"
                                    class="nav-item">
                                    <a v-on:click="changeTab(section)"
                                        role="tab" tabindex="-1" href="javascript:void(0)"
                                        :class="['nav-link', 'nav-link-left', section == currentSection ? 'active' : '']"
                                        >{{ __(section, ['titleCase']) }}</a>
                                </li>
                            </ul>
                        </div>
                        <div class="tab-content col no-border">
                            <div role="tabpanel" class="tab-pane show fade active">
                                <fieldset role="group" class="b-form-group form-group" v-if="_.get(config, 'formToolbar')">
                                    <div role="group" class="">
                                        <div class="row">
                                            <div class="col">
                                                <div style="position: absolute; right: 16px;">
                                                    <button
                                                        v-if="isCreating"
                                                        v-on:click="submit"
                                                        :disabled="$v.entryMap.$invalid"
                                                        class="btn btn-success" role="button"
                                                        >Create</button>
                                                    <button
                                                        v-if="!isCreating"
                                                        v-on:click="submit"
                                                        id="inline-form-button"
                                                        :disabled="$v.entryMap.$invalid"
                                                        class="btn btn-primary" role="button"
                                                        >Save</button>
                                                    <button
                                                        v-if="!isCreating && config.deletable"
                                                        v-on:click="deleteItem"
                                                        class="btn btn-danger" role="button"
                                                        >Delete</button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </fieldset>
                                <!-- group container -->
                                <component v-for="group in entryGroups"
                                    v-show="!_.isEmpty(getGroupEntries(group))"
                                    v-bind="group"
                                    v-on:input="onEntryInput(null)"
                                    :key="id + group.name"
                                    :section="currentSection"
                                    :is="group.component">
                                    <!-- form item slot -->
                                    <div v-for="entry in getGroupEntries(group)"
                                        v-if="(entry.group == group.name)"
                                        :key="id + entry.name"
                                        :slot="entry.name"
                                        :class="[(entry.section === currentSection && !entry.disabled) ? '' : 'hide', entry.cssClass]">
                                        <!-- form item component -->
                                        <component
                                            v-if="_.isObject(entry.component)"
                                            v-on:input="(newValue) => {
                                                touchFieldValidation(entry.name); onEntryChange(entry, newValue, entry.value);
                                            }"
                                            v-on:error="pushError"
                                            v-on:submit="submit"
                                            v-model="entry.value"
                                            :timestamp="timestamp"
                                            :label="entry.label"
                                            :description="entry.description || ''"
                                            :error="getFieldMessage(entry.name)"
                                            :state="getFieldState(entry.name)"
                                            :disabled="entry.readonly"
                                            :required="entry.isRequired"
                                            :position="entry.position"
                                            :config="entry"
                                            :data="attributes"
                                            :parent="parent"
                                            :show="entry.section === currentSection && !entry.disabled"
                                            :is="entry.component"
                                            ></component>

                                        <template v-else>
                                            <input v-if="entry.component === 'hidden'" type="hidden" v-model="entry.value">

                                            <b-form-group
                                                v-if="entry.component === 'string'"
                                                :invalid-feedback="getFieldMessage(entry.name)"
                                                :label="entry.label"
                                                :label-for="entry.name">
                                                <b-input-group :prepend="_.get(entry, 'prefix', null)" :append="_.get(entry, 'suffix', null)">
                                                    <b-form-input
                                                        type="text"
                                                        autocomplete="off"
                                                        v-on:input="(newValue) => { touchFieldValidation(entry.name); onEntryInput(entry, newValue) }"
                                                        v-on:change="(newValue) => { onEntryInteract(entry, newValue) }"
                                                        v-model="entry.value"
                                                        :formatter="entry.formatter || (val => val)"
                                                        :maxlength="entry.length || 255"
                                                        :disabled="entry.readonly"
                                                        :state="getFieldState(entry.name)"
                                                        :tabindex="entry.position"
                                                        :required="entry.isRequired">
                                                    </b-form-input>
                                                </b-input-group>
                                                <small v-if="entry.description" class="form-text mb-2"><em>{{ entry.description }}</em></small>
                                            </b-form-group>

                                            <b-form-group
                                                v-if="entry.component === 'slug'"
                                                :invalid-feedback="getFieldMessage(entry.name)"
                                                :label="entry.label"
                                                :label-for="entry.name">
                                                <b-input-group :prepend="_.get(entry, 'prefix', null)" :append="_.get(entry, 'suffix', null)">
                                                    <b-form-input
                                                        type="text"
                                                        lazy-formatter
                                                        autocomplete="off"
                                                        v-model="entry.value"
                                                        v-on:input="(newValue) => { touchFieldValidation(entry.name); onEntryInput(entry, newValue) }"
                                                        v-on:change="(newValue) => { onEntryInteract(entry, newValue) }"
                                                        :formatter="slugify"
                                                        :disabled="entry.readonly"
                                                        :state="getFieldState(entry.name)"
                                                        :maxlength="entry.length || 255"
                                                        :tabindex="entry.position"
                                                        :required="entry.isRequired">
                                                    </b-form-input>
                                                </b-input-group>
                                                <small v-if="entry.description" class="form-text mb-2"><em>{{ entry.description }}</em></small>
                                            </b-form-group>

                                            <b-form-group
                                                v-if="entry.component === 'number'"
                                                :invalid-feedback="getFieldMessage(entry.name)"
                                                :label="entry.label"
                                                :label-for="entry.name">
                                                <b-input-group :prepend="_.get(entry, 'prefix', null)" :append="_.get(entry, 'suffix', null)">
                                                    <b-form-input
                                                        type="number"
                                                        autocomplete="off"
                                                        v-model="entry.value"
                                                        v-on:input="(newValue) => { touchFieldValidation(entry.name); onEntryInput(entry, newValue) }"
                                                        v-on:change="(newValue) => { onEntryInteract(entry, newValue) }"
                                                        :state="getFieldState(entry.name)"
                                                        :tabindex="entry.position"
                                                        :disabled="entry.readonly"
                                                        :required="entry.isRequired">
                                                    </b-form-input>
                                                </b-input-group>
                                                <small v-if="entry.description" class="form-text mb-2"><em>{{ entry.description }}</em></small>
                                            </b-form-group>

                                            <b-form-group
                                                v-if="entry.component === 'select'"
                                                :invalid-feedback="getFieldMessage(entry.name)"
                                                :label="entry.label"
                                                :label-for="entry.name">
                                                <b-form-select
                                                    v-model="entry.value"
                                                    v-on:input="(newValue) => { touchFieldValidation(entry.name); onEntryChange(entry, newValue, entry.value) }"
                                                    :state="getFieldState(entry.name)"
                                                    :tabindex="entry.position"
                                                    :disabled="entry.readonly"
                                                    :required="entry.isRequired">
                                                    <template v-if="!entry.readonly">
                                                    <option v-if="!entry.isRequired || !entry.value" :value="null" :disabled="entry.isRequired">-- None --</option>
                                                    <option v-for="option in entry.values" :key="option.id" :value="option.id">{{ option.name }}</option>
                                                    </template>
                                                </b-form-select>
                                                <small v-if="entry.description" class="form-text mb-2"><em>{{ entry.description }}</em></small>
                                            </b-form-group>

                                            <b-form-group
                                                v-if="entry.component === 'array'"
                                                :invalid-feedback="getFieldMessage(entry.name)"
                                                :state="getFieldState(entry.name)"
                                                :tabindex="entry.position"
                                                :label="entry.label"
                                                :label-for="entry.name">
                                                <input-tag
                                                    :tags.sync="entry.value"
                                                    v-on:update:tags="(newValue) => { touchFieldValidation(entry.name); onEntryChange(entry, newValue, entry.value) }"
                                                    placeholder=""
                                                    validate="text"
                                                    autocomplete="off"
                                                    :required="entry.isRequired">
                                                </input-tag>
                                                <small v-if="entry.description" class="form-text mb-2"><em>{{ entry.description }}</em></small>
                                            </b-form-group>

                                            <b-form-group
                                                v-if="entry.component === 'date'"
                                                :invalid-feedback="getFieldMessage(entry.name)"
                                                :label="entry.label"
                                                :label-for="entry.name">
                                                <b-input-group>
                                                    <b-input-group-prepend>
                                                        <div class="input-group-text"><i class="fa fa-calendar" /></div>
                                                    </b-input-group-prepend>
                                                    <datetimepicker
                                                        v-model="entry.value"
                                                        v-on:input="(newValue) => { touchFieldValidation(entry.name); onEntryInput(entry, newValue) }"
                                                        v-on:change="(newValue) => { onEntryInteract(entry, newValue) }"
                                                        :config="{ format:'YYYY-MM-DD', showTodayButton: true, showClear: true, useCurrent: false }"
                                                        :state="getFieldState(entry.name)"
                                                        :tabindex="entry.position"
                                                        :disabled="entry.readonly"
                                                        :required="entry.isRequired" />
                                                </b-input-group>
                                                <small v-if="entry.description" class="form-text mb-2"><em>{{ entry.description }}</em></small>
                                            </b-form-group>

                                            <b-form-group
                                                v-if="entry.component === 'time'"
                                                :invalid-feedback="getFieldMessage(entry.name)"
                                                :label="entry.label"
                                                :label-for="entry.name">
                                                <b-input-group>
                                                    <b-input-group-prepend>
                                                        <div class="input-group-text"><i class="fa fa-clock-o" /></div>
                                                    </b-input-group-prepend>
                                                    <datetimepicker
                                                        v-model="entry.value"
                                                        v-on:input="(newValue) => { touchFieldValidation(entry.name); onEntryInput(entry, newValue) }"
                                                        v-on:change="(newValue) => { onEntryInteract(entry, newValue) }"
                                                        :config="{ format:'HH:mm:ss', showTodayButton: true, showClear: true, useCurrent: false }"
                                                        :state="getFieldState(entry.name)"
                                                        :tabindex="entry.position"
                                                        :disabled="entry.readonly"
                                                        :required="entry.isRequired" />
                                                </b-input-group>
                                                <small v-if="entry.description" class="form-text mb-2"><em>{{ entry.description }}</em></small>
                                            </b-form-group>

                                            <b-form-group
                                                v-if="entry.component === 'datetime'"
                                                :invalid-feedback="getFieldMessage(entry.name)"
                                                :label="entry.label"
                                                :label-for="entry.name">
                                                <b-input-group>
                                                    <b-input-group-prepend>
                                                        <div class="input-group-text"><i class="fa fa-calendar" /></div>
                                                    </b-input-group-prepend>
                                                    <datetimepicker
                                                        v-model="entry.value"
                                                        v-on:input="(newValue) => { touchFieldValidation(entry.name); onEntryInput(entry, newValue) }"
                                                        v-on:change="(newValue) => { onEntryInteract(entry, newValue) }"
                                                        :config="{ format:'YYYY-MM-DD HH:mm:ss', sideBySide: true, showClear: true, useCurrent: false }"
                                                        :state="getFieldState(entry.name)"
                                                        :tabindex="entry.position"
                                                        :disabled="entry.readonly"
                                                        :required="entry.isRequired" />
                                                </b-input-group>
                                                <small v-if="entry.description" class="form-text mb-2"><em>{{ entry.description }}</em></small>
                                            </b-form-group>


                                            <input-switch-component
                                                v-if="entry.component === 'checkbox'"
                                                v-on:input="(newValue) => { touchFieldValidation(entry.name); onEntryChange(entry, newValue, entry.value); }"
                                                v-on:error="pushError"
                                                v-model="entry.value"
                                                :timestamp="timestamp"
                                                :label="entry.label"
                                                :description="entry.description || ''"
                                                :error="getFieldMessage(entry.name)"
                                                :state="getFieldState(entry.name)"
                                                :position="entry.position"
                                                :disabled="entry.readonly"
                                                :required="entry.isRequired"
                                                :config="entry"
                                                :data="attributes"
                                                ></input-switch-component>

                                            <lazy-loading-select-component
                                                v-if="entry.component === 'ref'"
                                                v-on:input="(newValue) => { touchFieldValidation(entry.name); onEntryChange(entry, newValue, entry.value); }"
                                                v-on:error="pushError"
                                                v-model="entry.value"
                                                :timestamp="timestamp"
                                                :label="entry.label"
                                                :description="entry.description || ''"
                                                :error="getFieldMessage(entry.name)"
                                                :state="getFieldState(entry.name)"
                                                :position="entry.position"
                                                :disabled="entry.readonly"
                                                :required="entry.isRequired"
                                                :config="entry"
                                                :data="attributes"
                                                ></lazy-loading-select-component>

                                            <text-editor-component
                                                v-if="entry.component === 'text'"
                                                v-model="entry.value"
                                                v-on:input="(newValue) => { touchFieldValidation(entry.name); onEntryChange(entry, newValue, entry.value) }"
                                                v-on:error="pushError"
                                                :timestamp="timestamp"
                                                :state="getFieldState(entry.name)"
                                                :position="entry.position"
                                                :error="getFieldMessage(entry.name)"
                                                :label="entry.label"
                                                :description="entry.description || ''"
                                                :config="entry"
                                                :disabled="entry.readonly"
                                                :required="entry.isRequired"
                                                ></text-editor-component>

                                            <image-picker-component
                                                v-if="entry.component === 'asset'"
                                                v-on:input="(newValue) => { touchFieldValidation(entry.name); onEntryChange(entry, newValue, entry.value) }"
                                                v-on:error="pushError"
                                                v-model="entry.value"
                                                :timestamp="timestamp"
                                                :label="entry.label"
                                                :description="entry.description || ''"
                                                :extensions="entry.extensions"
                                                :error="getFieldMessage(entry.name)"
                                                :state="getFieldState(entry.name)"
                                                :position="entry.position"
                                                :disabled="entry.readonly"
                                                :required="entry.isRequired"
                                                :config="entry"
                                                :data="attributes"
                                                ></image-picker-component>

                                            <address-autocomplete-component
                                                v-if="entry.component === 'address'"
                                                v-on:input="(newValue) => { touchFieldValidation(entry.name); onEntryChange(entry, newValue, entry.value) }"
                                                v-on:error="pushError"
                                                v-model="entry.value"
                                                :timestamp="timestamp"
                                                :label="entry.label"
                                                :description="entry.description || ''"
                                                :error="getFieldMessage(entry.name)"
                                                :state="getFieldState(entry.name)"
                                                :position="entry.position"
                                                :disabled="entry.readonly"
                                                :required="entry.isRequired"
                                                :config="entry"
                                                ></address-autocomplete-component>

                                            <map-marker-component
                                                v-if="entry.component === 'map-marker'"
                                                v-on:input="(newValue) => { touchFieldValidation(entry.name); onEntryChange(entry, newValue, entry.value) }"
                                                v-on:error="pushError"
                                                v-model="entry.value"
                                                :timestamp="timestamp"
                                                :label="entry.label"
                                                :description="entry.description || ''"
                                                :error="getFieldMessage(entry.name)"
                                                :state="getFieldState(entry.name)"
                                                :position="entry.position"
                                                :disabled="entry.readonly"
                                                :required="entry.isRequired"
                                                :config="entry"
                                                :data="attributes"
                                                :schema="schema"
                                                ></map-marker-component>

                                            <multi-select-array-component
                                                v-if="entry.component === 'multi-select-array'"
                                                v-on:input="(newValue) => { touchFieldValidation(entry.name); onEntryChange(entry, newValue, entry.value) }"
                                                v-on:error="pushError"
                                                v-model="entry.value"
                                                :timestamp="timestamp"
                                                :label="entry.label"
                                                :description="entry.description || ''"
                                                :values="entry.values"
                                                :error="getFieldMessage(entry.name)"
                                                :state="getFieldState(entry.name)"
                                                :position="entry.position"
                                                :disabled="entry.readonly"
                                                :required="entry.isRequired"
                                                :config="entry"
                                                :data="attributes"
                                                ></multi-select-array-component>

                                            <password-confirm-component
                                                v-if="entry.component === 'password'"
                                                v-on:input="(newValue) => { touchFieldValidation(entry.name); onEntryChange(entry, newValue, entry.value) }"
                                                v-on:error="pushError"
                                                v-model="entry.value"
                                                :timestamp="timestamp"
                                                :label="entry.label"
                                                :description="entry.description || ''"
                                                :error="getFieldMessage(entry.name)"
                                                :state="getFieldState(entry.name)"
                                                :position="entry.position"
                                                :disabled="entry.readonly"
                                                :required="entry.isRequired"
                                                :config="entry"
                                                :data="attributes"
                                                ></password-confirm-component>
                                        </template>
                                        <!-- end form item component -->
                                    </div>
                                </component>
                                <!-- end group component -->
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Vue from 'vue';
import V from 'voca';
import M from 'moment';

import { validationMixin } from 'vuelidate';
import { required, email, url, numeric, alphaNum } from 'vuelidate/lib/validators';

import VueSelect from 'vue-select';
import InputTag from 'vue-input-tag';
import Datetimepicker from 'vue-bootstrap-datetimepicker';

import TextEditorComponent from './form-elements/TinymceEditorComponent';
// import TextEditorComponent from './form-elements/TextEditorComponent';
import FilePickerComponent from './form-elements/FilePickerComponent';
import ImagePickerComponent from './form-elements/ImagePickerComponent';
import MapMarkerComponent from './form-elements/MapMarkerComponent';
import AddressAutocompleteComponent from './form-elements/AddressAutocompleteComponent';
import MultiSelectArrayComponent from './form-elements/MultiSelectArrayComponent';
import LazyLoadingSelectComponent from './form-elements/LazyLoadingSelectComponent';
import PasswordConfirmComponent from './form-elements/PasswordConfirmComponent';
import InputSwitchComponent from './form-elements/InputSwitchComponent';

export default {

    mixins: [validationMixin],

    data () {
        return {
            initialized: false,
            randomKey: _.uniqueId('form_'),
            currentSection: null,
            entries: [],
            formConfig: {},
            sections: [],
            fieldConfigs: {},
            entryMap: {},
            recentData: {},
        }
    },

    props: [
        'id', 'resourceParams', 'type', 'config', 'parent',
        'attributes', 'meta', 'schema', 'timestamp', 'section',
        'createData', 'updateData', 'deleteData',
        'changeQuery', 'changeUrl', 'changeSection', 'haltFetch',
        'onCreated', 'onUpdated', 'onDeleted', 'onChanged', 'onInitialized',
        'addNotification', 'bindKeys', 'commitQueue', 'pushQueue',
    ],

    validations() {
        const validators = _.chain(this.entries)
            .filter((entry) => {
                const { endpoint, relationship } = this.resourceParams;
                const parent = relationship ? endpoint : null;

                return !(entry.type === 'ref' && entry.relationship === parent);
            })
            .map((entry) => {
                const validators = {};

                // check required if it's not a binary value
                if (entry.isRequired && ['tinyint'].indexOf(entry.type) < 0) {
                    validators.required = required;
                }

                switch (entry.type) {
                    case 'url': validators.url = url; break;
                    case 'email': validators.email = email; break;
                    default: break;
                }

                return [entry.name, validators];
            })
            .fromPairs()
            .value();

        return { entryMap: validators };
    },

    watch: {
        timestamp: {
            handler() {
                const formConfig = this.config;
                const sections = _.get(formConfig, 'sections', ['details']);
                const fieldConfigs = _.get(formConfig, 'fields', {});

                const entries = this.prepareDataEntries(sections, fieldConfigs);
                const entryMap = entries
                    .filter(entry => entry.type)
                    .reduce((tmp, entry) => ({
                        ...tmp, [entry.name]: this.convertDataToRequest(entry.value, entry.type)
                    }), {});

                this.formConfig = formConfig;
                this.sections = sections;
                this.fieldConfigs = fieldConfigs;
                this.entries = entries;
                this.entryMap = entryMap;
                this.currentSection = this.section ? decodeURI(this.section) : _.first(sections);

                // store a clone of data to prevent endless loop
                this.recentData = _.cloneDeep(this.attributes);

                this.$v.$reset();
                this.$forceUpdate();

                if (!this.initialized) {
                    this.entries.forEach(entry => {
                        this.onEntryInitialize(entry);
                    })
                    this.initialized = true;
                }
            },
            immediate: true,
        },

        section(newSection) {
            this.currentSection = newSection || _.first(this.sections);
        },
    },

    components: {
        AddressAutocompleteComponent,
        MultiSelectArrayComponent,
        LazyLoadingSelectComponent,
        PasswordConfirmComponent,
        FilePickerComponent,
        ImagePickerComponent,
        MapMarkerComponent,
        TextEditorComponent,
        InputSwitchComponent,

        VueSelect,
        InputTag,
        Datetimepicker,
    },

    computed: {
        isCreating() {
            return !this.id;
        },

        isVersionable() {
            return this.meta && this.meta.versions;
        },

        revisions() {
            const { versions } = this.meta;
            return [{ value: '', text: 'current' }, ...versions.map(id => ({ value: id, text: id }))];
        },

        entryErrors() {
            let validatorErrors = {};
            if (this.entries.length > 0) {
                validatorErrors = this.entries.reduce((tmp, entry) => {
                    if (this.getFieldStatus(entry.name) ||
                        !this.getFieldMessage(entry.name)
                    ) {
                        return tmp;
                    }
                    return { ...tmp, [entry.name]: this.getFieldMessage(entry.name) };
                }, {})
            }

            return validatorErrors;
        },

        entryGroups() {
            const config = _.get(this.formConfig, 'groups', {});

            return _.chain(this.entries)
                .map(entry => _.get(entry, 'group', entry.name)).uniq()
                .map(groupName => {
                    const defaultGroupComponent = {
                        template: `<div><slot name="${groupName}"></slot></div>`,
                    };

                    const groupConfig = _.get(config, groupName, {});
                    return {
                        name: groupName,
                        component: defaultGroupComponent,
                        data: this.recentData,
                        ...groupConfig,
                    };
                })
                .value()
        }
    },

    mounted() {
        // trigger field listeners
        // this.entries.forEach(entry => this.onEntryInitialize(entry));
        this.onInitialized(this.type, 'form-component', { ...this.formConfig, submit: this.submit });
        console.log('Component mounted.');
    },

    created() {
        if (this.bindKeys) {
            console.log('Bind keys');
            window._isMeta = false;
            _.subscribe('key.down', this.randomKey, this.keydownListener)
            _.subscribe('key.up', this.randomKey, this.keyupListener)
        }
    },

    destroyed() {
        if (this.bindKeys) {
            console.log('Unbind keys');
            window._isMeta = false;
            _.unsubscribe('key.down', this.randomKey);
            _.unsubscribe('key.up', this.randomKey);
        }
    },

    methods: {
        keydownListener(event) {
            console.log(`key down ${event.key}`);
            if (event.key == 'Meta') {
                window._isMeta = true;
            }

            if (event.key == 's' && (window._isMeta || event.ctrlKey)) {
                event.preventDefault();
                this.submit();
            }
        },

        keyupListener(event) {
            console.log(`key up ${event.key}`);
            if (event.key == 'Meta') {
                window._isMeta = false;
            }
        },

        deleteItem() {
            this.deleteData({ setNotification: true })
                .then(() => this.onDeleted(this.type));
        },

        submit() {
            // this.initialized = false;
            this.entries.forEach(entry => {
                this.onEntryChange(entry, entry.value);
            })

            const data = this.entries.reduce((tmp, entry) => {
                return { ...tmp, [entry.name]: this.convertDataToRequest(entry.value, entry.type) };
            }, {});

            const fieldErrorPairs = _.toPairs(this.entryErrors);
            if (fieldErrorPairs.length > 0) {
                return Promise.resolve(null)
                    .then(() => this.addNotification({
                        type: 'error',
                        message: fieldErrorPairs.map(([field, error]) => `${V.capitalize(field).replace('_', ' ')}: ${error}`),
                    }))
            }

            if (this.isCreating) {
                // halt fetching data when updating route
                if (_.isFunction(this.haltFetch)) {
                    this.haltFetch();
                }
                return this.createData(data, { setNotification: true, updateRoute: true })
                    .then((response) => this.onCreated(this.type, response))
                    .then(() => {
                        this.entries.forEach(entry => {
                            this.onEntryInitialize(entry, entry.value);
                        })
                    })
            } else {
                let res;
                return this.updateData(data, { setNotification: true })
                    .then((response) => res = response)
                    .then(() => this.commitQueue())
                    .then(() => this.onUpdated(this.type, res))
                    .then(() => {
                        this.entries.forEach(entry => {
                            this.onEntryInitialize(entry, entry.value);
                        })
                    })
            }
        },

        convertDataType(dataType) {
            switch(dataType) {
                case 'int': return 'number';
                case 'decimal': return 'number';

                case 'password': return 'password';
                case 'location': return 'map-marker';
                case 'address': return 'address';
                case 'string': return 'string';
                case 'array': return 'array';
                case 'asset': return 'asset';
                case 'slug': return 'slug';
                case 'url': return 'string';

                case 'text': return 'text';

                case 'date': return 'date';

                case 'time': return 'time';

                case 'datetime':
                case 'timestamp': return 'datetime';

                case 'enum': return 'select';
                case 'ref': return 'ref';

                case 'boolean': return 'checkbox';
                case 'tinyint': return 'checkbox';
                default: return 'string';
            }
        },

        convertDataToForm(value, type) {
            switch(type) {
                case 'int': return value ? parseInt(value) : null;

                // case 'array': return value ? String(value).split(/[\,\;]/) : [];
                case 'string': return value ? String(value) : '';
                case 'url': return value ? String(value) : '';
                case 'ref': return value || null;

                case 'text': return value ? String(value) : '';

                case 'tinyint': return Boolean(parseInt(value));

                case 'boolean': return Boolean(value);

                case 'date': return value || null;

                default: return value;
            }
        },

        convertDataToRequest(value, type) {
            switch(type) {
                case 'asset': return value || null;
                case 'address': return _.isObject(value) ? value.formatted_address : value;
                case 'ref': return _.isObject(value) ? value.id : value;
                default: value = _.isObject(value) ? value.id : value;
            }

            switch(type) {
                case 'int': return value ? parseInt(value) : null;

                case 'string': return value ? String(value) : null;
                // case 'array': return value ? value.join(',') : null;
                case 'url': return value ? String(value) : null;

                case 'text': return value ? String(value) : null;

                case 'tinyint': return value ? 1 : 0;
                case 'boolean': return value ? 1 : 0;

                case 'date': return value ? M(value).format('YYYY-MM-DD') : null;

                default: return value || null;
            }
        },

        prepareDataEntries(sections, fieldConfigs) {
            const defaultConfig = {
                disabled: true,
            }

            return _.chain(fieldConfigs)
                .toPairs()
                .map(([key, fieldConfig]) => ({
                    name: key,
                    group: key,
                    label: this.formatLabel(key),
                    value: this.convertDataToForm(
                        _.get(this.attributes, key) || _.get(this.schema, `${key}.default`),
                        _.get(this.schema, `${key}.type`)
                    ),
                    component: this.convertDataType(_.get(this.schema, `${key}.type`)),

                    ..._.get(this.schema, key),

                    // check readonly fields
                    readonly: _.get(this.meta, 'readonly', []).indexOf(key) >= 0,

                    values: _.get(this.schema, `${key}.values`) ?
                        _.get(this.schema, `${key}.values`, []).map(value => _.isObject(value) ? value : { id: value, name: value }) : null,

                    // merge field with its config or default config if not defined
                    ..._.chain(fieldConfig)
                        .toPairs()
                        .map(([configKey, configHandler]) => {
                            let configValue;
                            if (['listener', 'formatter'].indexOf(configKey) >= 0) {
                                configValue = configHandler;
                            } else if (_.isFunction(configHandler)) {
                                configValue = configHandler.call(
                                    this, this.attributes[key], this.schema[key], this.attributes
                                );
                            } else {
                                configValue = configHandler;
                            }

                            return [configKey, configValue];
                        })
                        .fromPairs()
                        .value()
                }))
                .sort((a, b) => {
                    return _.get(a, 'position', Number.MAX_SAFE_INTEGER) >= _.get(b, 'position', Number.MAX_SAFE_INTEGER) ? 1 : -1;
                })
                // filter out parent key
                .filter(itemSchema => {
                    const { endpoint, relationship } = this.resourceParams;
                    const parent = relationship ? endpoint : null;

                    return !(itemSchema.type === 'ref' && itemSchema.relationship === parent);
                })
                .value()
        },

        getGroupEntries(group) {
            return _.chain(this.entries)
                .filter(entry => entry.group == group.name && !entry.disabled)
                .value();
        },

        getSectionEntries(section) {
            return _.chain(this.entries)
                .filter(entry => entry.section == section && !entry.disabled)
                .value();
        },

        touchFieldValidation(name) {
            const fieldValidation = this.$v.entryMap[name];
            if (fieldValidation) fieldValidation.$touch();
        },

        getFieldState(name) {
            const fieldValidation = this.$v.entryMap[name];
            if (!fieldValidation) return null;
            if (!fieldValidation.$dirty) return null;

            // disable success state
            if (!fieldValidation.$invalid) return null;
            return false;
        },

        getFieldStatus(name) {
            const fieldValidation = this.$v.entryMap[name];
            if (!fieldValidation) return null;
            return !fieldValidation.$invalid;
        },

        getFieldMessage(name) {
            const fieldValidation = this.$v.entryMap[name];
            if (!fieldValidation) return;

            const constraints = _.keys(fieldValidation.$params);

            let errorMessages = [];
            constraints.forEach(constraint => {
                const result = fieldValidation[constraint];
                if (result) return;

                switch(constraint) {
                    case 'required': errorMessages.push('This field is required'); break;
                    case 'alphaNum': errorMessages.push('Only characters and numbers allowed'); break;
                    case 'url': errorMessages.push('The URL provided is not valid'); break;
                    case 'email': errorMessages.push('The email provided is not valid'); break;
                    case 'numeric': errorMessages.push('Only numbers allowed'); break;
                    default: errorMessages.push('The input is not valid'); break;
                }
            })

            return errorMessages[0] || '';
        },

        onEntryInput(changedEntry, newValue) {
            if (changedEntry) {
                this.entryMap[changedEntry.name] = this.convertDataToRequest(newValue, changedEntry.type);
            }
            this.onChanged({
                data: this.entryMap,
                errors: this.entryErrors,
            });
        },

        onEntryInteract(changedEntry, newValue) {
            this.entries.forEach(entry => {
                if (typeof(entry.listener) == 'function') {
                    entry.listener.apply(entry, [{ ...changedEntry, newValue }, this.entries, this]);
                }
            });
        },

        onEntryChange(changedEntry, newValue, oldValue = null) {
            this.entries.forEach(entry => {
                if (typeof(entry.listener) == 'function') {
                    entry.listener.apply(entry, [{ ...changedEntry, newValue }, this.entries, this]);
                }
            });

            this.entryMap[changedEntry.name] = this.convertDataToRequest(newValue, changedEntry.type);
            this.onChanged({
                data: this.entryMap,
                errors: this.entryErrors,
            });
        },

        onEntryInitialize(initEntry) {
            this.entries.forEach(entry => {
                if (initEntry.name == entry.name) return;
                if (entry.listener && typeof(entry.listener) == 'function') {
                    entry.listener.apply(entry, [
                        { ...initEntry }, this.entries, this
                    ]);
                }
            });
        },

        changeTab(section) {
            this.currentSection = section;
            this.changeSection(section);
        },

        changeRevision(revisionId) {
            this.changeQuery({
                rev: revisionId,
            });
        },

        activate() {
            this.updateData({ activate: 1, }, { setNotification: true });
        },

        deactivate() {
            this.updateData({ deactivate: 1, }, { setNotification: true });
        },

        publish() {
            this.updateData({ publish: 1, }, { setNotification: true });
        },

        formatLabel(val) {
            return V.capitalize(val).replace(/[\_]/g, ' ');
        },

        getEntryErrors() {
            return this.entryErrors;
        },

        pushError(keyErrorMap) {
            this.onChanged({
                data: this.entryMap,
                errors: _.chain({ ...this.entryErrors, ...keyErrorMap })
                    .toPairs()
                    .filter(([key, msg]) => !!msg)
                    .fromPairs()
                    .value(),
            });
        },

        titleCase(val) {
            return V.titleCase(val);
        },

        slugify(val) {
            return V.slugify(val);
        }
    }
}
</script>



// WEBPACK FOOTER //
// seventytwo/72cms-ui/src/components/FormComponent.vue